
import { Http, LinkedIn } from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import { useGlobal } from "../../utils/GlobalContext";
import { useEffect, useState } from "react";
import { UserProfile } from "../../data/userProfile";
import HTMLReactParser from "html-react-parser";

export default function AboutStaffComponent({ eventID }: { eventID?: string }) {

    const { state } = useGlobal();
    const [staff, setStaff] = useState<UserProfile[]>();
    useEffect(()=>{
        if(state.SelectedEvent.Staff.length!=0 && staff==undefined){
            let filteredStaff: UserProfile[]=[];
            for(let p=0; p< state.Profiles.length; p++){
              for (let i = 0; i < state.SelectedEvent.Staff.length; i++) {
                if(state.Profiles[p].PresentationSessions.find((element) => 
                element.EventId === state.SelectedEvent.Sessions[i].EventId && element.SessionId === state.SelectedEvent.Sessions[i].Id
                )!==undefined)
                {
                filteredStaff.push(state.Profiles[p]);
                    break;
                }
              }
            }
            setStaff(filteredStaff);
        }
    });

    return (
    <>
        <br/>
        <br/>
        <center>
            <h2 className="blueText">{state.SelectedEvent.Name}  Staff</h2>
            <div>
                {HTMLReactParser(state.Conference.StaffDescription ?? "")}
            </div>
            <br/>
            <br/>
        </center>
        <center>
            <h3>Board Members</h3>
            <Grid container spacing={4}>
            {
                state.SelectedEvent.Staff.map((staffmember) => (
                <> 
                    {
                     staffmember.Position === "Officer" && state.Profiles.map((profile) => (
                        (staffmember as { UserId: string }).UserId === profile?.Id && 
                            <>
                                <Grid item xs={6} md={2}>
                                    <center>
                                        <img className='StaffImage' src={profile?.PictureLink} alt=""/>
                                        <div>{profile?.FirstName} {profile?.LastName}</div>
                                        <LinkedIn /> &nbsp; &nbsp; <Http />
                                    </center>
                                </Grid>
                            </>
                        )
                    )
                    }
                </>
                ))
            }
            </Grid>
        </center>
        <br/>
        <br/>
        <center>
            <h3>Volunteers</h3>
            <Grid container spacing={4}>
            {
                state.SelectedEvent.Staff.map((staffmember) => (
                <> 
                    {
                     (staffmember as { Position: string }).Position !== "Officer" &&
                     state.Profiles.map((profile) => (
                    (staffmember as { UserId: string }).UserId === profile?.Id && 
                        <>
                            <Grid item xs={6} md={2}>
                                <center>
                                    <img className='StaffImage' src={profile?.PictureLink} alt=""/>
                                    <div>{profile?.FirstName} {profile?.LastName}</div>
                                    <LinkedIn /> &nbsp; &nbsp; <Http />
                                </center>
                            </Grid>
                        </>
                    )
                    )
                    }
                </>
                ))
            }
        </Grid>
        </center>
        
        <br/>
        <br/>
        <br/>
    </>
    )
}